// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-menu {\n  border: 0px !important;\n  background: var(--portal-surface);\n  border: 1px solid var(--portal-border) !important;\n  box-shadow: var(--portal-shadow-sm);\n  color: var(--portal-text);\n}\n.notification-item {\n  padding-left: 12px !important;\n  padding-right: 12px !important;\n}\n.notification-icon {\n  color: var(--portal-text-muted);\n}\n.notification-count {\n  position: relative;\n  top: 5px;\n  left: -4px;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
